export const emptyRequest: () => Promise<void> = (): Promise<void> => new Promise<void>((resolve: () => void): void => {
  resolve();
});
